'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["fieldName", "filterFamily", "getReferencedObjectType", "getSpecialOptionsForReferenceType", "InputComponent", "onChange", "resolver", "value", "onBlur"];
import FilterOperatorType from 'customer-data-filters/components/propTypes/FilterOperatorType';
import PropTypes from 'prop-types';
import { memo, useCallback } from 'react';
import ReferenceResolverLiteType from 'reference-resolvers-lite/components/proptypes/ReferenceResolverLiteType';
import ReferenceResolverType from 'reference-resolvers/schema/ReferenceResolverType';
import { syntheticEvent as SyntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import { jsx as _jsx } from "react/jsx-runtime";
const getIsMulti = (fieldName, operator) => operator.constructor.isIterableField(fieldName);
const FilterOperatorValueInput = props => {
  const {
      fieldName,
      filterFamily,
      getReferencedObjectType,
      getSpecialOptionsForReferenceType,
      InputComponent,
      onChange,
      resolver,
      value,
      onBlur
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const handleChange = useCallback(({
    target: {
      value: nextValue
    }
  }, options) => {
    if (options && options.hasClickedUpdate) {
      onChange(SyntheticEvent(value.set(fieldName, nextValue).set('hasTimezones', false)));
    } else {
      onChange(SyntheticEvent(value.set(fieldName, nextValue)));
    }
  }, [fieldName, onChange, value]);
  const specialOptions = getSpecialOptionsForReferenceType(getReferencedObjectType(filterFamily, value));
  return /*#__PURE__*/_jsx(InputComponent, Object.assign({}, rest, {
    condition: value,
    field: value.field,
    fieldType: value.field.type,
    filterFamily: filterFamily,
    multi: getIsMulti(fieldName, value),
    numberDisplayHint: value.field.numberDisplayHint,
    onBlur: onBlur,
    onChange: handleChange,
    options: value.field.options,
    resolver: resolver,
    showCurrencySymbol: !!value.field.showCurrencySymbol,
    specialOptions: specialOptions,
    value: value.get(fieldName)
  }));
};
FilterOperatorValueInput.propTypes = {
  InputComponent: PropTypes.func.isRequired,
  fieldName: PropTypes.string.isRequired,
  filterFamily: PropTypes.string.isRequired,
  getReferencedObjectType: PropTypes.func.isRequired,
  getSpecialOptionsForReferenceType: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  resolver: PropTypes.oneOfType([ReferenceResolverType, ReferenceResolverLiteType, PropTypes.func]),
  value: FilterOperatorType.isRequired
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
FilterOperatorValueInput.defaultProps = {
  fieldName: 'value'
};
export default /*#__PURE__*/memo(FilterOperatorValueInput);